export default "__VITE_ASSET__lLGerqc3__"